import React from 'react';
import {getReactClass} from './index'
import {isObservableArray} from 'mobx'
import {inject, observer, Provider} from 'mobx-react'
import wrapUIComponent from './MetaDataMapper'
import {FlatDomainDataContext, FormBean, IUICompositeComponentDef} from '../../../app/datatypes';
import { BaseUIComponent, BaseUIComponentProps } from './BaseUIComponent';

const dataGridFields = [
    'TextInputCol', 'SwitchCol', 'CurrencyCol', 'RadioCol', 'CheckboxCol', 'DropdownCol', 'NumberCol', 'PhoneNumberCol', 'EmailCol', 'DateCol'
]

/**
 * render children components.
 * 
 * @param props 
 */
export default function renderChildUIComponents(props:{metadata:IUICompositeComponentDef, 
                                                       formBean:FormBean, 
                                                       ctx:FlatDomainDataContext}
                                                ) {
  const {metadata, formBean, ctx} = props;
  if(!metadata.children || metadata.children.length<1) return null;

  return metadata.children.map((compMetadata, idx) => {
      const compName= compMetadata.type;
      let Comp = getReactClass(compName);
      if(!Comp){
        console.error(`Unknown UI component type ${compName}`);
        return null;
      }
    //   console.debug(`render component type:${compName} componentId:${compMetadata.componentId}`);
 
      const WrappedComp = wrapUIComponent(Comp);
      let key = (compMetadata.componentId)+(ctx.namePrefix ? `_${ctx.namePrefix}` : '');
      if(!key){
          console.warn(`UI component missing key`, compMetadata);
      }

      if (!ctx) throw `Ctx not defined for ${compName} for ${metadata.type}`
      
      let field = compMetadata.componentId && compMetadata.componentId.includes(".") ? compMetadata.componentId.split(".")[compMetadata.componentId.split(".").length-1]
          :compMetadata.componentId;

      let dataGridField = dataGridFields.includes(compName);

      return <WrappedComp key={key} metadata={compMetadata} ctx={ctx} formBean={formBean} 
                          cId={field} dataGridField={dataGridField}/>
    })
}
